import React, { FC } from "react";
import { Fade } from "react-awesome-reveal";
import classNames from "classnames";
import { DEFAULT_FADE_DURATION } from "@app/constants";
import { InnerTextBlock, RichText } from "../../models";
import {
  BlockHeader,
  HeaderLevel,
} from "../../../common/block-header/BlockHeader";
import { BlockBody } from "../../../common/block-body/BlockBody";

type Props = {
  advantages: InnerTextBlock[];
  title?: RichText;
};

export const AdvantagesList: FC<Props> = ({ advantages, title }) => (
  <div
    className={classNames(
      "mx-5 mt-20",
      "md:mx-auto md:max-w-[660px]",
      "lg:mt-25",
      "xl:mt-40 xl:w-[58%] xl:max-w-[980px]",
    )}
  >
    <div
      className={classNames(
        "text-medium text-primary-content text-center",
        "lg:text-medium",
        "xl:text-large",
        { "mb-15 xl:mb-25": title?.content[0]?.content?.length },
      )}
    >
      <Fade duration={DEFAULT_FADE_DURATION} triggerOnce>
        <BlockHeader richText={title} />
      </Fade>
    </div>
    <Fade duration={DEFAULT_FADE_DURATION} triggerOnce>
      {advantages.map((advantage) => (
        <div
          key={advantage._uid}
          className={classNames(
            "flex justify-between py-6",
            "border-divider border-t",
            "md:py-7",
            "xl:py-12",
          )}
        >
          <div
            className={classNames(
              "text-regular text-primary-content w-[41%]",
              "md:text-medium",
              "xl:text-large xl:w-[38%]",
            )}
          >
            <BlockHeader
              richText={advantage.title}
              headerLevel={HeaderLevel.H4}
            />
          </div>
          <div
            className={classNames(
              "text-extra-small text-neutral-content w-1/2",
              "md:text-regular",
              "xl:text-medium",
            )}
          >
            <BlockBody richText={advantage.text} />
          </div>
        </div>
      ))}
    </Fade>
  </div>
);
